module.exports = __webpack_public_path__ + "img/chilltrax.ef8817de.png";